const hostnameApiMap: { [key: string]: string } = {
  'cedato-dashboard.ex.co': 'https://cedato-dashboard.ex.co/api/',
  'stg-cedato-dashboard.ex.co': 'https://stg-cedato-dashboard.ex.co/api/',
  'dashboard-featurestage.cedato.com': 'https://dashboard-featurestage.cedato.com/api/',
  'dashboard-dev.cedato.com': 'https://newdashboard.dev.cedato.com/api/',
  'showroomng.cedato.com': 'https://showroomng.cedato.com/api/',
  'dashboard-rnd-taldick-terra-01-dashboard.cdtx.co': 'https://dashboard-rnd-taldick-terra-01-dashboard.cdtx.co/api/',
  'local-dashboard.cedato.com': 'http://dashboard.cedato.docker:8090/',
  'dashboard.cedato.docker': 'http://dashboard.cedato.docker:8090/',
  'dashboard.cedato.com': 'https://dashboard.cedato.com/api/'
};

const defaultApiURL = 'https://stg-cedato-dashboard.ex.co/api/';

export const environment = {
  name: 'production',
  type: 'dashboard',
  production: true,
  apiURL: hostnameApiMap[window.location.hostname] || defaultApiURL,
};
